import axios from 'axios'

export default {
    getKeperluan(){
        return axios.get('/keperluan')
            .then(response => {
                return response.data
            })
    },
    getKeperluanDataSource(params){
        return axios.get('/keperluan/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getKeperluanbyID(id){
        return axios.get('/keperluan/' + id)
            .then(response => {
                return response.data
            })
    },    
    createKeperluan(formdata){
        return axios.post('/keperluan', formdata)
            .then(response => {
                return response.data
            })
    },
    updateKeperluan(id,formdata){
        return axios.put('/keperluan/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateKeperluan(id){
        return axios.put('/keperluan/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateKeperluan(id){
        return axios.put('/keperluan/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    
}